var styles = {
  global: {
    body: {
      color: 'black',
      fontWeight: 'normal',
      lineHeight: '24px'
    },
    heading: {
      color: 'black',
      fontWeight: 'normal',
      lineHeight: '26px'
    },
    '.DateRangePicker': {
      position: {
        sm: 'unset',
        md: 'relative'
      }
    }
  }
};
export default styles;
//# sourceMappingURL=styles.js.map